<template>
	<span
		v-if="quotaText"
		data-test="quota-count"
		class="sgnl-paragraph-m-regular sgnl-text-color-tertiary"
		>{{ quotaText }}</span
	>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

import type { UserLimits } from "@/js/tierconfig";
import { useUserStore } from "@/stores/user";

export default defineComponent({
	name: "QuotaCount",
	props: {
		used: { type: Number, required: true },
		limitId: { type: String as PropType<UserLimits>, required: true },
	},
	setup() {
		const userStore = useUserStore();
		return { userStore };
	},
	computed: {
		quotaText(): string | null {
			const limit = this.userStore.currentUserTierDetails?.allowance[this.limitId];
			return typeof limit === "number" ? `${this.used}/${limit}` : null;
		},
	},
});
</script>
